import { useVideoControls } from "@/src/hooks/features/posts/use-video-controls";
import { VideoView } from "expo-video";
import { CloseCircle, Play } from "iconsax-react-nativejs";
import { DimensionValue, Pressable, View } from "react-native";

type VideoPreviewProps = Readonly<{
  uri: string;
  onRemove?: () => void;
  width?: DimensionValue;
  height?: DimensionValue;
  closeButton?: boolean;
}>;

const VideoPreview = ({
  uri,
  onRemove,
  width = "100%",
  height = 100,
  closeButton = false,
}: VideoPreviewProps) => {
  const { player, isPlaying, togglePlay } = useVideoControls(uri, true);

  return (
    <View className="overflow-hidden mr-2" style={{ width, height }}>
      <VideoView
        player={player}
        style={{ width, height }}
        nativeControls={false}
        contentFit="contain"
      />

      {/* Play/pause overlay */}
      <Pressable
        onPress={togglePlay}
        className={`absolute inset-0 justify-center items-center ${
          isPlaying ? "bg-transparent" : "bg-black/35"
        }`}
      >
        {!isPlaying && (
          <View className="w-7 h-7 rounded-full bg-black/50 items-center justify-center">
            <Play size={16} variant="Outline" color="white" />
          </View>
        )}
      </Pressable>

      {/* Remove button */}
      {closeButton && (
        <Pressable
          onPress={onRemove}
          className="absolute top-1 right-1 rounded-full bg-black/50 hover:bg-ash-3"
        >
          <CloseCircle size={16} color="white" />
        </Pressable>
      )}
    </View>
  );
};

export default VideoPreview;
